export class BillSessionFileLocationDetail {
	public accountNumberIdentifier?: string;
	public accountNumber?: string;
	public meterNumberIdentifier?: string;
	public meterNumber?: string[];
	public nameKeyIdentifier?: string;
	public nameKey?: string;
	public referenceNumIdentifier?: string;
	public referenceNum?: string;
	public state?: string;
	public city?: string;
	public address1?: string;
	public serviceAddress?: string;
	public zipCode?: string;
	public rateClass?: string;
	public usageHistory?: { month: string; usage: number; temperature: number }[];
	public totalUsage?: number;
	public annualUsage?: { value?: number; startDate?: string; endDate?: string };
	public taxRate?: number;
	public taxCharge?: number;
	public supplyRate?: number;
	public supplyCharge?: number;
	public deliveryCharge?: number;
	public deliveryRate?: number;
	public otherCharges?: string[];
	public temperatureUnit?: string;
	public usageHistoryLabel?: string;
	public usageHistoryUnit?: string;

	constructor(billSessionFileLocationDetail?: BillSessionFileLocationDetail) {
		Object.assign(this, billSessionFileLocationDetail);
	}
}
